import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function SwitchSetting(props) {
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <FormControlLabel
              control={
                <Switch
                  color={props.color ? props.color : "primary"}
                  disabled={!write}
                  checked={!!props.setting.value}
                  onChange={(e) => {
                    props.onChange(e.target.checked);
                  }}
                />
              }
              label={props.label}
            />
            {props.children}
          </>
        );
      }}
    />
  );
}

export default SwitchSetting;
